import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-one-columns-two-page',
  templateUrl: './courses-grid-style-one-columns-two-page.component.html',
  styleUrls: ['./courses-grid-style-one-columns-two-page.component.scss']
})
export class CoursesGridStyleOneColumnsTwoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
